import { useRef } from "react"
import { v4 as uuid } from "uuid"

export default function useAutoId(id) {
  const { current: autoId } = useRef(id || uuid())
  return autoId
}
